/* eslint-disable max-len */
import { addClass, toggleClass, wootOn, removeClass } from './DOMHelpers';
import { IFrameHelper } from './IFrameHelper';
import { BUBBLE_DESIGN } from './constants';

export const body = document.getElementsByTagName('body')[0];
export const widgetHolder = document.createElement('div');

export const bubbleHolder = document.createElement('div');
export const chatBubble = document.createElement('div');
export const closeBubble = document.createElement('div');

const RESPONSIVE_BREAKPOINT = 670;

var timer = 0;
var CloseWidgetPopupDIV;
var closepopupJSON;
var popupConfigsJSON;
var firstTimePopUp;
var unreadPopUp;
var unreadBadge;
var lastToggleTime = 0;

// Widget scroll hiding functionality
let scrollHandler = null;
let isWidgetHiddenOnScroll = false;
let scrollShowTimeout = null;

// Timer tracking for cleanup
let appearanceTimers = new Set();
let mediaValidationTimers = new Set();

// Helper function to hide widget with transition based on position
const hideWidgetWithTransition = (position) => {
  if (bubbleHolder) {
    bubbleHolder.style.transition =
      'opacity 0.3s ease-out, transform 0.3s ease-out';
    if (position === 'left') {
      bubbleHolder.style.transform = 'translateX(-100%)';
    } else {
      bubbleHolder.style.transform = 'translateX(100%)';
    }
    bubbleHolder.style.opacity = '0';
    setTimeout(() => {
      if (bubbleHolder) {
        bubbleHolder.style.display = 'none';
      }
    }, 300);
  }
};

// Helper function to show widget with transition based on position
const showWidgetWithTransition = (position) => {
  if (bubbleHolder) {
    bubbleHolder.style.display = '';
    bubbleHolder.style.transition =
      'opacity 0.3s ease-out, transform 0.3s ease-out';
    if (position === 'left') {
      bubbleHolder.style.transform = 'translateX(-100%)';
    } else {
      bubbleHolder.style.transform = 'translateX(100%)';
    }
    bubbleHolder.style.opacity = '0';
    // Force reflow
    bubbleHolder.offsetWidth; // eslint-disable-line no-unused-expressions
    bubbleHolder.style.transform = 'translateX(0)';
    bubbleHolder.style.opacity = '1';
  }
};

// Helper function to set up scroll handler for widget hiding
const setupWidgetScrollHandler = () => {
  // Don't set up if already exists
  if (scrollHandler) {
    return;
  }

  // Determine device type and corresponding hide-on-scroll flag
  const isMobile = window.innerWidth <= RESPONSIVE_BREAKPOINT;

  const shouldDisappear = isMobile
    ? window.$chatwoot.disappearOnScrollingMobile
    : window.$chatwoot.disappearOnScrollingDesktop;

  if (!shouldDisappear) {
    return;
  }

  // Use default scroll threshold of 75px (similar to previous implementation)
  const threshold = 75;
  const showDelay = 1500; // 1.5 seconds delay before showing after scroll stops

  let initialScrollY = window.scrollY;

  scrollHandler = () => {
    // Don't hide widget if it's currently open (chat is active)
    if (window.$chatwoot.isOpen) {
      return;
    }

    const currentY = window.scrollY;
    const position = isMobile
      ? window.$chatwoot.position_mobile
      : window.$chatwoot.position;

    // If not already hidden and scrolled beyond threshold, hide widget
    if (
      !isWidgetHiddenOnScroll &&
      Math.abs(currentY - initialScrollY) > threshold
    ) {
      hideWidgetWithTransition(position);
      isWidgetHiddenOnScroll = true;
    }

    // When hidden, debounce showing until delay after scrolling stops
    if (isWidgetHiddenOnScroll) {
      if (scrollShowTimeout) {
        clearTimeout(scrollShowTimeout);
      }
      scrollShowTimeout = setTimeout(() => {
        showWidgetWithTransition(position);
        isWidgetHiddenOnScroll = false;
        initialScrollY = window.scrollY;
        scrollShowTimeout = null;
      }, showDelay);
    }
  };

  window.addEventListener('scroll', scrollHandler);
};

// Helper function to remove scroll handler
const removeWidgetScrollHandler = () => {
  if (scrollHandler) {
    window.removeEventListener('scroll', scrollHandler);
    scrollHandler = null;
  }

  if (scrollShowTimeout) {
    clearTimeout(scrollShowTimeout);
    scrollShowTimeout = null;
  }

  isWidgetHiddenOnScroll = false;

  // Reset widget visibility and transform
  if (bubbleHolder) {
    bubbleHolder.style.display = '';
    bubbleHolder.style.opacity = '1';
    bubbleHolder.style.transform = 'translateX(0)';
    bubbleHolder.style.transition = '';
  }
};

export const getBubbleView = (type) =>
  BUBBLE_DESIGN.includes(type) ? type : BUBBLE_DESIGN[2];
export const isExpandedView = (type) =>
  getBubbleView(type).split('_')[0] === 'expanded';

export const setBubbleText = (bubbleText, type) => {
  // Set bubble text for expanded. if not bubble text in config, then set default text
  if (isExpandedView(type)) {
    const sizeType = getBubbleView(type);
    const textNode = document.getElementById(`woot-widget--${sizeType}__text`);
    if (textNode) {
      if (bubbleText) {
        textNode.innerHTML = bubbleText;
      } else {
        textNode.innerHTML = 'Chat with us';
      }
    }
  }
};

export const createBubbleIcon = ({ className, src, target }, type) => {
  const sizeType = getBubbleView(type);
  let bubbleClassName = `${className} woot-widget--${sizeType}`;
  const bubbleIcon = document.createElement('img');
  bubbleIcon.src = src;
  bubbleIcon.alt = 'bubble-icon';
  target.appendChild(bubbleIcon);

  if (isExpandedView(type)) {
    const textNode = document.createElement('div');
    textNode.id = `woot-widget--${sizeType}__text`;
    textNode.innerHTML = '';
    target.appendChild(textNode);
  }

  target.className = bubbleClassName;
  return target;
};

export const createBubbleHolder = () => {
  addClass(
    bubbleHolder,
    window.innerWidth >= RESPONSIVE_BREAKPOINT
      ? `woot--bubble-holder`
      : `woot--bubble-holder`
  );

  if (
    window.innerWidth >= RESPONSIVE_BREAKPOINT &&
    window.$chatwoot.position === 'left'
  ) {
    bubbleHolder.setAttribute(
      'style',
      `left: ${window.$chatwoot.leftMargin}px;
      bottom: ${window.$chatwoot.bottomMargin}px;
      align-items: flex-start;
      `
    );
  } else if (
    window.innerWidth >= RESPONSIVE_BREAKPOINT &&
    window.$chatwoot.position === 'right'
  ) {
    bubbleHolder.setAttribute(
      'style',
      `right: ${window.$chatwoot.rightMargin}px;
      bottom: ${window.$chatwoot.bottomMargin}px;
      align-items: flex-end;
      `
    );
  } else if (
    window.innerWidth <= RESPONSIVE_BREAKPOINT &&
    window.$chatwoot.position_mobile === 'left'
  ) {
    bubbleHolder.setAttribute(
      'style',
      `left: ${window.$chatwoot.leftMargin_mobile}px;
      bottom: ${window.$chatwoot.bottomMargin_mobile}px;
      align-items: flex-end;
      z-index: ${window.$chatwoot.widgetZIndex};
      `
    );
  } else if (
    window.innerWidth <= RESPONSIVE_BREAKPOINT &&
    window.$chatwoot.position_mobile === 'right'
  ) {
    bubbleHolder.setAttribute(
      'style',
      `right: ${window.$chatwoot.rightMargin_mobile}px;
      bottom: ${window.$chatwoot.bottomMargin_mobile}px;
      align-items: flex-end;
      z-index: ${window.$chatwoot.widgetZIndex};
      `
    );
  }

  body.appendChild(bubbleHolder);

  // Set up scroll handler for widget hiding functionality
  setupWidgetScrollHandler();
};

// Utility functions for URL validation
const isValidUrl = (url) => {
  try {
    const urlObj = new URL(url);
    return !!urlObj;
  } catch {
    return false;
  }
};

const validateAndCreateImage = (imageSrc, callback) => {
  if (!isValidUrl(imageSrc)) {
    // eslint-disable-next-line no-console
    console.warn('Invalid image URL format:', imageSrc);
    return;
  }

  const img = new Image();
  img.onload = () => callback();
  // eslint-disable-next-line no-console
  img.onerror = () => console.warn('Failed to load image:', imageSrc);

  const timerId = setTimeout(() => {
    if (!img.complete) {
      // eslint-disable-next-line no-console
      console.warn('Image loading timeout:', imageSrc);
    }
    mediaValidationTimers.delete(timerId);
  }, 10000);

  mediaValidationTimers.add(timerId);

  img.src = imageSrc;
};

const validateAndCreateVideo = (videoSrc, callback) => {
  if (!isValidUrl(videoSrc)) {
    // eslint-disable-next-line no-console
    console.warn('Invalid video URL format:', videoSrc);
    return;
  }

  const video = document.createElement('video');
  video.onloadedmetadata = () => callback();
  // eslint-disable-next-line no-console
  video.onerror = () => console.warn('Failed to load video:', videoSrc);
  // eslint-disable-next-line no-console
  video.onabort = () => console.warn('Video loading aborted:', videoSrc);

  const timerId = setTimeout(() => {
    if (video.readyState === 0) {
      // eslint-disable-next-line no-console
      console.warn('Video loading timeout:', videoSrc);
    }
    mediaValidationTimers.delete(timerId);
  }, 15000);

  mediaValidationTimers.add(timerId);

  video.src = videoSrc;
  video.load();
};

// Popup creation helper functions
const createCloseButton = () => {
  const closeButton = document.createElement('span');
  closeButton.id = 'lime-close-first-time-popup';
  closeButton.className = 'lime-popup-close-button';
  closeButton.textContent = '✕';
  return closeButton;
};

const createImageContainer = (imageSrc) => {
  const imageContainer = document.createElement('div');
  imageContainer.className = 'lime-popup-image-container';

  const popupImage = document.createElement('img');
  popupImage.id = 'lime--popup-image';
  popupImage.className = 'lime-popup-image';
  popupImage.src = imageSrc;
  popupImage.alt = 'Popup image';

  imageContainer.appendChild(popupImage);
  return imageContainer;
};

const createVideoContainer = (videoSrc) => {
  const videoContainer = document.createElement('div');
  videoContainer.className = 'lime-popup-image-container';

  const popupVideo = document.createElement('video');
  popupVideo.id = 'lime--popup-video';
  popupVideo.className = 'lime-popup-image';
  popupVideo.src = videoSrc;
  popupVideo.autoplay = true;
  popupVideo.muted = true;
  popupVideo.loop = true;
  popupVideo.playsInline = true;
  popupVideo.controls = false;
  popupVideo.setAttribute('preload', 'auto');

  videoContainer.appendChild(popupVideo);
  return videoContainer;
};

const createTextContainer = (config) => {
  const textContainer = document.createElement('div');
  textContainer.className = 'lime-popup-text-container';

  // Create wrapper for header and body with horizontal padding
  if (config.header || config.body) {
    const textContentWrapper = document.createElement('div');
    textContentWrapper.className = 'lime-popup-text-content';

    if (config.header) {
      const header = document.createElement('h3');
      header.className = 'lime-popup-header';
      header.textContent = config.header;
      textContentWrapper.appendChild(header);
    }

    if (config.body) {
      const bodyText = document.createElement('p');
      bodyText.className = 'lime-popup-body';
      bodyText.textContent = config.body;
      textContentWrapper.appendChild(bodyText);
    }

    textContainer.appendChild(textContentWrapper);
  }

  if (config.cta) {
    const ctaContainer = document.createElement('div');
    ctaContainer.className = 'lime-popup-cta-container';

    const ctaButton = document.createElement('button');
    ctaButton.id = 'lime-cta-button';
    ctaButton.className = 'lime-popup-cta-button';
    ctaButton.textContent = config.cta;

    ctaContainer.appendChild(ctaButton);
    textContainer.appendChild(ctaContainer);
  }

  return textContainer;
};

const createCompanyImageContainer = (companySrc) => {
  const companyImageContainer = document.createElement('div');
  companyImageContainer.className = 'lime-popup-company-image-container';

  const companyImage = document.createElement('img');
  companyImage.className = 'lime-popup-company-image';
  companyImage.src = companySrc;
  companyImage.alt = 'Company logo';

  companyImageContainer.appendChild(companyImage);
  return companyImageContainer;
};

const addPopupStyles = (widgetColor = '#9EE34A') => {
  // Avoid adding styles multiple times
  if (document.getElementById('lime-popup-styles')) {
    return;
  }

  const styleElement = document.createElement('style');
  styleElement.id = 'lime-popup-styles';
  styleElement.textContent = `
    .lime-first-time-popup {
      transition: opacity 0.3s ease-out, transform 0.3s ease-out;
      opacity: 1;
      transform: translateY(0);
    }

    .lime-first-time-popup.lime-popup-hidden {
      opacity: 0;
      transform: translateY(20px);
    }

    .lime-popup-content {
      position: relative;
    }

    /* Video popup specific styling for desktop */
    .popup-type-video .lime-popup-content {
      width: 172px;
      height: 262px;
      border-radius: 12px;
      display: flex;
      flex-direction: column;
    }

    .lime-popup-close-button {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      top: -18px;
      right: -14px;
      background-color: white;
      color: #808975;
      font-size: 12px;
      font-weight: normal;
      line-height: 1;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      border: 0.5px solid silver;
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      user-select: none;
    }

    .lime-popup-close-button:hover {
      background-color: #e0e0e0;
    }

    .lime-popup-image-container {
      width: 100%;
      height: 90px;
      position: relative;
    }

    /* Video container styling for desktop */
    .popup-type-video .lime-popup-image-container {
      flex: 1;
    }

    .lime-popup-image {
      width: 100%;
      height: 100%;
      border-radius: 12px;
      object-fit: cover;
    }

    .lime-popup-text-container {
      padding: 0px;
    }

    .lime-popup-text-content {
      padding: 0px 8px;
    }

    .lime-popup-company-image-container {
      position: absolute;
      bottom: -16px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 10;
    }

    .lime-popup-company-image {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #fff;
    }

    /* Adjust spacing when company image is present */
    .lime-popup-content.has-company-image .lime-popup-text-content {
      padding-top: 10px;
    }

    /* No media header case - add top padding, but not if company image is first child */
    .lime-popup-content > .lime-popup-text-container:first-child:not(.lime-has-company-image) {
      padding-top: 10px;
    }

    .lime-popup-header {
      font-size: 12px;
      font-weight: 600;
      margin: 8px 0px 4px 0px;
      padding: 0px;
      letter-spacing: 0.2px;
      line-height: 1.4;
    }

    .lime-popup-body {
      margin: 4px 0px;
      padding: 0px;
      font-size: 11px;
      font-weight: 400;
      color: #434343;
      line-height: 18px;
    }

    .lime-popup-cta-container {
      margin-top: 8px;
    }

    .lime-popup-cta-button {
      width: 100%;
      background-color: ${widgetColor};
      color: white;
      border: none;
      border-radius: 8px;
      padding: 10px 16px;
      font-weight: 600;
      font-size: 12px;
      text-align: center;
      text-transform: capitalize;
      line-height: 20px;
      cursor: pointer;
    }

    .lime-popup-cta-button:hover {
      opacity: 0.9;
    }

    .lime-first-time-popup::before,
    .lime-first-time-popup::after {
      content: none !important;
      display: none !important;
    }

    /* Mobile adjustments */
    @media (max-width: ${RESPONSIVE_BREAKPOINT}px) {
      /* Video popup content styling for mobile */
      .popup-type-video .lime-popup-content {
        width: 172px;
        height: 262px;
        display: flex;
        flex-direction: column;
      }

      /* Video container styling for mobile */
      .popup-type-video .lime-popup-image-container {
        flex: 1;
      }
    }
  `;
  document.head.appendChild(styleElement);
};

const getPopupPositionClasses = (config) => {
  let popupClasses = 'lime-first-time-popup';
  if (window.innerWidth < RESPONSIVE_BREAKPOINT) {
    popupClasses += ` lime-first-time-popup--${
      config.message_position || 'top'
    }-${window.$chatwoot.position_mobile} lime-first-time-popup--${
      config.message_position || 'top'
    }-${window.$chatwoot.position_mobile}-${window.$chatwoot.type_mobile}`;
  } else {
    popupClasses += ` lime-first-time-popup--${
      config.message_position || 'top'
    }-${window.$chatwoot.position} lime-first-time-popup--${
      config.message_position || 'top'
    }-${window.$chatwoot.position}-${window.$chatwoot.type}`;
  }
  return popupClasses;
};

const setupPopupBehavior = (config) => {
  let disappearTimer = null;

  const closePopupGracefully = () => {
    if (firstTimePopUp && firstTimePopUp.parentNode === bubbleHolder) {
      // Clear any active disappear timer
      if (disappearTimer) {
        clearTimeout(disappearTimer);
        disappearTimer = null;
      }

      addClass(firstTimePopUp, 'lime-popup-hidden');
      setTimeout(() => {
        if (firstTimePopUp && firstTimePopUp.parentNode === bubbleHolder) {
          bubbleHolder.removeChild(firstTimePopUp);
          firstTimePopUp = null;
        }
      }, 300);
    }
  };

  let timerControls = null;

  // Handle auto-disappear with hover pause/restart
  if (config.time_to_disappear) {
    const timerDuration = parseInt(config.time_to_disappear, 10) * 1000;

    const startTimer = () => {
      // Clear any existing timer first
      if (disappearTimer) {
        clearTimeout(disappearTimer);
      }
      disappearTimer = setTimeout(() => {
        closePopupGracefully();
      }, timerDuration);
    };

    const pauseTimer = () => {
      if (disappearTimer) {
        clearTimeout(disappearTimer);
        disappearTimer = null;
      }
    };

    const restartTimer = () => {
      if (!disappearTimer) {
        startTimer();
      }
    };

    // Don't start timer immediately - wait for popup to be fully ready
    // startTimer(); // Removed this line

    // Add hover event listeners
    if (firstTimePopUp) {
      firstTimePopUp.addEventListener('mouseenter', pauseTimer);
      firstTimePopUp.addEventListener('mouseleave', restartTimer);
    }

    // Store timer controls to be accessed later
    timerControls = {
      start: startTimer,
      pause: pauseTimer,
      restart: restartTimer,
      clear: () => {
        if (disappearTimer) {
          clearTimeout(disappearTimer);
          disappearTimer = null;
        }
      },
    };
  }

  return { closePopupGracefully, timerControls };
};

const setupPopupEventListeners = (config, closePopupGracefully) => {
  const openWidget = () => {
    closePopupGracefully();
    onBubbleClick({ toggleValue: true });
  };

  // Close button handler
  const closeButton = document.getElementById('lime-close-first-time-popup');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.stopPropagation();
      closePopupGracefully();
    });
  }

  // CTA button handler
  const ctaButton = document.getElementById('lime-cta-button');
  if (ctaButton) {
    ctaButton.addEventListener('click', (e) => {
      e.stopPropagation();
      openWidget();
    });
  }

  // Make entire popup clickable if no CTA or if it's a video popup
  if (!config.cta || config.popup_type === 'video') {
    firstTimePopUp.addEventListener('click', (e) => {
      const isClickOnCloseButton =
        e.target.id === 'lime-close-first-time-popup' ||
        e.target.closest('#lime-close-first-time-popup') !== null;
      if (!isClickOnCloseButton) {
        e.preventDefault();
        e.stopPropagation();
        openWidget();
      }
    });
  }
};

export const onBubbleClick = (props = {}) => {
  if (timer) {
    clearTimeout(timer);
    timer = 0;
  }

  const now = Date.now();
  const timeSinceLastToggle = now - lastToggleTime;
  // ignore rapid toggle
  if (timeSinceLastToggle < 300 && props.toggleValue === undefined) {
    return;
  }

  if (props.toggleValue !== undefined) {
    lastToggleTime = now;
  }

  let iframe = widgetHolder.querySelector('iframe');

  // for desktop, Set the z-index of the widget holder to the configured value
  if (window.innerWidth >= RESPONSIVE_BREAKPOINT) {
    widgetHolder.style.zIndex = window.$chatwoot.widgetZIndex;
  }

  if (iframe.src === '') {
    let src = iframe.getAttribute('data-src');
    iframe.src = src;
  }

  const { toggleValue } = props;
  const { isOpen } = window.$chatwoot;

  // Fix: Only toggle if toggleValue is explicitly set or if isOpen needs to be toggled
  // This prevents double-toggling when opening from CTA button
  const shouldOpen =
    toggleValue === true || (toggleValue === undefined && !isOpen);
  const shouldClose =
    toggleValue === false || (toggleValue === undefined && isOpen);

  // Only proceed if we need to change the current state
  if ((shouldOpen && !isOpen) || (shouldClose && isOpen)) {
    const newIsOpen = shouldOpen;

    window.$chatwoot.isOpen = newIsOpen;

    // If opening the widget and it was hidden due to scrolling, show it
    if (newIsOpen && isWidgetHiddenOnScroll) {
      const isMobile = window.innerWidth <= RESPONSIVE_BREAKPOINT;
      const position = isMobile
        ? window.$chatwoot.position_mobile
        : window.$chatwoot.position;
      showWidgetWithTransition(position);
      isWidgetHiddenOnScroll = false;

      // Clear any pending show timeout since we're manually showing it
      if (scrollShowTimeout) {
        clearTimeout(scrollShowTimeout);
        scrollShowTimeout = null;
      }
    }

    toggleClass(bubbleHolder, 'woot--hide');
    toggleClass(widgetHolder, 'woot--hide');

    if (popupConfigsJSON) {
      if (firstTimePopUp) {
        firstTimePopUp.style.display = 'none';
      }
    }

    if (unreadPopUp) {
      unreadPopUp.style.display = 'none';
    }

    if (unreadBadge) {
      unreadBadge.style.display = 'none';
    }

    if (!(closepopupJSON === undefined)) {
      if (!newIsOpen && closepopupJSON.closeuppopupEnabled) {
        createCloseWidgetPopUp();
      } else if (CloseWidgetPopupDIV)
        toggleClass(CloseWidgetPopupDIV, 'woot--hide');
    }

    IFrameHelper.events.onBubbleToggle(newIsOpen);
  }
};

export const onClickChatBubble = () => {
  wootOn(bubbleHolder, 'click', onBubbleClick);
};

export const initializeClosepopupJSON = (jsonFromIframeHelper) => {
  closepopupJSON = jsonFromIframeHelper;
};

const createCloseWidgetPopUp = () => {
  CloseWidgetPopupDIV = document.createElement('div');

  if (window.$chatwoot.position === 'left') {
    CloseWidgetPopupDIV.innerHTML = `
      <div >
        <!-- Canvas -->
        <!-- Overlay -->
        <div id="lime--overlay2" class="overlay2 closepopupleft">
          <!-- Overlay inner wrapper -->
          <div class="overlay__inner">
            <!-- Title -->
            <div  class="close-button-wrapper closepopupleftclosebutton">
              <button id="lime--closepopup"  type="button" class="material-icons exit-chat mobile-close" aria-label="Close chat widget">
                <svg id="ic_close" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                  <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </button>
            </div>

            <!-- Description -->
            <p class="overlay__description">
              ${closepopupJSON.closeuppopupText}
            </p>

            <!-- Buttons -->
            <div class="overlay__btns">
              <button class="overlay__btn">
              <p id="entertext"  class="overlay__description">
                Enter your message...
              </p>
            </div>
          </div>
        </div>
      </div>
    `;
  } else {
    CloseWidgetPopupDIV.innerHTML = `
      <div >
        <!-- Canvas -->
        <!-- Overlay -->
        <div id="lime--overlay2"  class="overlay2">
          <!-- Overlay inner wrapper -->
          <div class="overlay__inner">
            <!-- Title -->
            <div class="close-button-wrapper">
              <button id="lime--closepopup"  type="button" class="material-icons exit-chat mobile-close" aria-label="Close chat widget">
                <svg id="ic_close" fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                  <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </button>
            </div>

            <!-- Description -->
            <p class="overlay__description">
              ${closepopupJSON.closeuppopupText}
            </p>

            <!-- Buttons -->
            <div class="overlay__btns">
              <button class="overlay__btn">
              <p  id="entertext"  class="overlay__description">
                Enter your message...
              </p>
            </div>
          </div>
        </div>
      </div>
    `;
  }
  document.body.appendChild(CloseWidgetPopupDIV);

  if (window.innerWidth >= RESPONSIVE_BREAKPOINT) {
    if (
      isExpandedView(window.$chatwoot.type) &&
      window.$chatwoot.position === 'right'
    ) {
      document.getElementById('lime--overlay2').style.right = '100px';
    }
  } else if (
    isExpandedView(window.$chatwoot.type_mobile) &&
    window.$chatwoot.position === 'right'
  ) {
    document.getElementById('lime--overlay2').style.right = '100px';
  }

  function closePopUp() {
    document.body.removeChild(CloseWidgetPopupDIV);
  }

  function openWidget() {
    document.body.removeChild(CloseWidgetPopupDIV);
    onBubbleClick({ toggleValue: true });
  }

  document.getElementById('lime--closepopup').addEventListener('click', () => {
    closePopUp();
  });

  document.getElementById('entertext').onclick = () => {
    openWidget();
  };
};

export const initializeFirstTimepopupJSON = (jsonFromIframeHelper) => {
  popupConfigsJSON = jsonFromIframeHelper;
};

// Validate if popup has meaningful content
const hasValidPopupContent = (config) => {
  const hasValidCta = config.cta && config.cta.trim() !== '';
  const hasValidMediaHeader =
    config.media_header && config.media_header.trim() !== '';
  const hasValidHeader = config.header && config.header.trim() !== '';
  const hasValidTitle = config.title && config.title.trim() !== '';
  const hasValidBody = config.body && config.body.trim() !== '';

  // Return true if at least one field has valid content
  return (
    hasValidCta ||
    hasValidMediaHeader ||
    hasValidHeader ||
    hasValidTitle ||
    hasValidBody
  );
};

export const createFirstTimeWidgetPopUp = (config, widgetColor = '#9EE34A') => {
  // Validate if popup has any meaningful content before creating it
  if (!hasValidPopupContent(config)) {
    return;
  }

  firstTimePopUp = document.createElement('div');

  // Build the popup content with modern styling
  const popupContent = document.createElement('div');
  popupContent.className = 'lime-popup-content';

  // Add close button
  popupContent.appendChild(createCloseButton());

  // Create a placeholder for media that will be inserted at the correct position
  const mediaPlaceholder = document.createElement('div');
  mediaPlaceholder.className = 'lime-media-placeholder';
  popupContent.appendChild(mediaPlaceholder);

  // Add text content if any text exists
  const hasText = config.header || config.body || config.cta;
  if (hasText) {
    popupContent.appendChild(createTextContainer(config));
  }

  // Add media (image or video) if provided and valid - insert at placeholder position
  if (config.media_header?.trim() !== '') {
    if (config.popup_type === 'video') {
      validateAndCreateVideo(config.media_header, () => {
        const videoContainer = createVideoContainer(config.media_header);
        popupContent.insertBefore(videoContainer, mediaPlaceholder);
        popupContent.removeChild(mediaPlaceholder);
      });
    } else {
      validateAndCreateImage(config.media_header, () => {
        const imageContainer = createImageContainer(config.media_header);

        // if header or body is also present, add company image
        if (config.header || config.body) {
          validateAndCreateImage(config.company_image, () => {
            const companyImageContainer = createCompanyImageContainer(
              config.company_image
            );
            imageContainer.appendChild(companyImageContainer);

            addClass(popupContent, 'has-company-image');
          });
        }
        popupContent.insertBefore(imageContainer, mediaPlaceholder);
        popupContent.removeChild(mediaPlaceholder);
      });
    }
  } else {
    // Remove placeholder if no media
    popupContent.removeChild(mediaPlaceholder);
  }

  firstTimePopUp.appendChild(popupContent);

  // Add CSS classes for positioning
  firstTimePopUp.className = getPopupPositionClasses(config);

  // Add popup type if provided
  if (config.popup_type) {
    addClass(firstTimePopUp, `popup-type-${config.popup_type}`);
  }

  // Insert the popup before the chat bubble
  bubbleHolder.insertBefore(firstTimePopUp, chatBubble);

  // Add CSS styles
  addPopupStyles(widgetColor);

  // Setup behavior and event listeners
  const { closePopupGracefully, timerControls } = setupPopupBehavior(config);
  setupPopupEventListeners(config, closePopupGracefully);

  // Store timer controls on popup element for cleanup
  if (timerControls) {
    firstTimePopUp.timerControls = timerControls;
  }

  // Start timer after popup is fully ready
  if (timerControls && timerControls.start) {
    timerControls.start();
  }
};

export const createUnreadWidgetPopUp = (
  unreadMessageCount,
  unreadMessages,
  isEnable
) => {
  if (!unreadBadge) {
    unreadBadge = document.createElement('div');
    unreadBadge.innerHTML = `${unreadMessageCount}`;
    unreadBadge.className = 'lime-unread-badge';
    chatBubble.appendChild(unreadBadge);
  } else {
    unreadBadge.style.display = 'flex';
    unreadBadge.innerHTML = `${unreadMessageCount}`;
  }

  let content = 'You Have Unread Messages';
  if (
    unreadMessages &&
    unreadMessages.length &&
    unreadMessages[0].content.length
  ) {
    content = unreadMessages[0].content;
  }
  if (!unreadPopUp && isEnable) {
    unreadPopUp = document.createElement('div');
    unreadPopUp.innerHTML = `<span>${content}</span>`;

    unreadPopUp.className = 'lime-unread-popup lime-unread-popup--animate';

    if (window.$chatwoot.position === 'right') {
      addClass(unreadPopUp, 'lime-unread-popup--right');
    }

    bubbleHolder.insertBefore(unreadPopUp, chatBubble);

    setTimeout(() => {
      removeClass(unreadPopUp, 'lime-unread-popup--animate');
    }, 1000);
  } else if (isEnable) {
    unreadPopUp.style.display = 'flex';
    addClass(unreadPopUp, 'lime-unread-popup--animate');
    unreadPopUp.innerHTML = `<span>${content}</span>`;

    setTimeout(() => {
      removeClass(unreadPopUp, 'lime-unread-popup--animate');
    }, 1000);
  }
};

// Helper function to clear all timers for cleanup
const clearAllTimers = () => {
  // Clear scroll handler and related timers
  removeWidgetScrollHandler();

  // Clear global timer
  if (timer) {
    clearTimeout(timer);
    timer = 0;
  }

  // Clear appearance timers
  appearanceTimers.forEach((timerId) => clearTimeout(timerId));
  appearanceTimers.clear();

  // Clear media validation timers
  mediaValidationTimers.forEach((timerId) => clearTimeout(timerId));
  mediaValidationTimers.clear();

  // Clear popup timers if they exist
  if (firstTimePopUp && firstTimePopUp.timerControls) {
    firstTimePopUp.timerControls.clear();
  }
};

// Add cleanup on page unload
window.addEventListener('beforeunload', clearAllTimers);
window.addEventListener('unload', clearAllTimers);
